// extracted by mini-css-extract-plugin
export default {"root":"_39fRC","variant-horizontal":"_3Kg7w","variantHorizontal":"_3Kg7w","title":"_1rLz5","message":"Ddtb1","core-star":"n9-yG","coreStar":"n9-yG"};